import { inject } from 'vue';
import { Emitter, Handler } from 'mitt';
import { TTrainingForward } from 'src/types/trainingType';

type TDemoLogin = {
  invalidATCode: undefined;
};
type TTrainingChatEvent = {
  startTraining: undefined;
  getResult: undefined;
  fetchTrainingForward: TTrainingForward;
  handlePass: undefined;
};
type TTrainingChatHeaderEvent = {
  handleTrainingHeaderButtonDisable: boolean;
};
type TTrainingDialogEvent = {
  openSimpleCenterDialog: string;
  openSingleButtonCenterDialog: string;
  openTwoButtonCenterDialog: string;
  onExit: undefined;
};
type TDemoTraining = {
  handleNextDemoAction: string;
};
type TPackingUpEvent = {
  // 짐을 챙겨라 (9201)
  clickPackingUpButton: number;
  addPackingUpAnswer: undefined;
  handlePackingUpButtonDisable: undefined;
  playRestartCountdown: undefined;
  handlePausedPackingUp: boolean;
  changeIsDialogOpen: boolean;
};
type TTodaysSouvenir = {
  // 오늘의 기념품은? (9202)
  handleTodaysSouvenirFinish: undefined;
};
type TWhereToEat = {
  // 어디서 뭐 먹지 (9301)
  handleQuestionCompletion: undefined;
};
type TFindVisitPath = {
  // 경로 찾기 (9302)
  showAnswer: undefined;
};
type TFindLuggage = {
  // 여행 짐아 어디있니? (9303)
  handleFindLuggageResult: boolean;
  setNextQuestion: undefined;
  resetBoard: undefined;
};
type TGuessPhotoViewpoint = {
  // 어디서 찍은 사진일까요 (9602)
  handleEachGuessPhotoViewpointResult: boolean;
};

type Events = {
  openAssessmentGuide: undefined;
  setTrainingListHeight: undefined;
  updateSubjective: undefined;
  sendMessage: string;
  userInputOnClick: undefined;
  userBirthOnClick: undefined;
  userGenderOnClick: undefined;
  userEducationOnClick: undefined;
  playAudio: string;
  setTrainingTimer: undefined;
  countUpTrainingQuestionCount: undefined;
  openExitDialog: undefined;
  openRetryDialog: string;
  sendPass: string;
  setQuestionEndTime: undefined;
  getTrainingResult: boolean;
  openCenterDialog: string;
  playCountdownLottie: undefined;
  handleCrosswordPuzzle: string;
  handleSequenceOrder: string;
  handleCorrectWhereAndWhat: undefined;
  handleIncorrectWhereAndWhat: undefined;
  handlePassWhereAndWhat: undefined;
  handleCorrectRotateLuggage: undefined;
  handleIncorrectRotateLuggage: undefined;
  handlePassRotateLuggage: undefined;
  handlePassAble: boolean;
  handleReceiptButtonDisabled: boolean;
  handleInputPassAble: boolean;
  micAccessInteraction: undefined;
  resetNoResponseTimer: undefined;
  updateQuestionStringIndex: number;
} & TDemoLogin &
  TTrainingChatEvent &
  TTrainingChatHeaderEvent &
  TTrainingDialogEvent &
  TDemoTraining &
  TPackingUpEvent &
  TTodaysSouvenir &
  TGuessPhotoViewpoint &
  TFindLuggage &
  TWhereToEat &
  TFindVisitPath;
type Key = keyof Events;
export type TEvents = undefined | TTrainingForward | string | boolean | number;

export default function useMitt() {
  const mitt = inject('mitt') as Emitter<Events>;

  const on = (key: keyof Events, handler: Handler<Events[Key]>) =>
    mitt.on(key, handler);
  const off = (key: keyof Events, handler: Handler<Events[Key]>) =>
    mitt.off(key, handler);

  const clear = () => mitt.all.clear();

  const emit = (key: keyof Events, event: Events[Key]) => mitt.emit(key, event);

  return { on, off, emit, clear };
}
